/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import h from "../../util/dom-builder.js";
import birdata from "../../api.js";
import util from "../../util/util.js";

export default function createPagedSightingList(criteria) {
	const pageSize = 100
	let div = h('div');

	function pageControl(prevCursor, nextCursor) {
		let items = []

		if(prevCursor) {
			var prev = h('span', { class: 'link', style: 'margin-right: 0.5em;' }, 'prev');
			prev.addEventListener('click', function() { loadPage(prevCursor); });
			items.push(prev);
		}

		if(nextCursor) {
			var next = h('span', { class: 'link', style: 'margin-left: 0.5em;' }, 'next');
			next.addEventListener('click', function() { loadPage(nextCursor); });
			items.push(next);
		}

		return h('div', { style: 'margin-top: 1em;' }, items);
	}

	function loadPage(cursor) {
		div.innerHTML = 'Loading…';
		var pageDataPromise = birdata.vettableSightings({
			sort: 'id',
			limit: pageSize,
			...cursor,
			...criteria
		});

		Promise.all([
			pageDataPromise,
			birdata.lookup()
		]).then(function([pageData, lookup]) {
			div.innerHTML = '';

			div.appendChild(h('h4', 'Sightings'));

			div.appendChild(h('table', { 'class': 'table' }, [
				h('thead',
					h('tr', [
						h('td', 'Date'),
						h('td', 'Species'),
						h('td', 'Status')
					])
				),
				h('tbody',
					pageData.map(function(sighting) {
						var date = util.formatDate(util.parseISODate(sighting.start_date));
						return h('tr', [
							h('td', h('a', { href: 'survey?id=' + sighting.survey_id, target: '_blank' }, date)),
							h('td', sighting.common_name),
							h('td', sighting.vetting_status)
						]);
					})
				)
			]));

			let prevCursor, nextCursor;
			let pageLen = pageData.length;
			if(pageLen > 0) {
				if(!pageData[0].first) {
					prevCursor = {
						cursor: pageData[0].cursor,
						previous: true,
						approximate_offset: pageData[0].approximate_offset
					};
				}
				if(!pageData[pageLen - 1].last) {
					nextCursor = {
						cursor: pageData[pageLen - 1].cursor,
						approximate_offset: pageData[pageLen - 1].approximate_offset
					}
				}
			}

			div.appendChild(pageControl(prevCursor, nextCursor));
		}).catch(function(error) {
			console.log(error);
			div.innerHTML = "Failed to load surveys"
		});
	}

	loadPage({ approximate_offset: 0, limit: pageSize });

	return div;
}
